interface FocusedRecordBannerProps {
  noun: 'student' | 'parent' | 'invoice' | 'enrollment' | 'payment';
  loading: boolean;
  found: boolean;
  onShowAll: () => void;
}

/**
 * Says why a directory shows a single row when it was opened from a link (see
 * `recordLinks`), and is the way back to the full list. Without it, a one-row Students page
 * reads as a search that went wrong.
 */
export function FocusedRecordBanner({ noun, loading, found, onShowAll }: FocusedRecordBannerProps) {
  return (
    <div className="mx-4 mt-4 px-4 py-2 flex items-center justify-between gap-3 rounded-md bg-blue-50 text-sm text-blue-800 flex-shrink-0">
      <span role="status">
        {!loading && !found
          ? `No ${noun} matches this link. They may have been deleted.`
          : `Showing one ${noun} from a link.`}
      </span>
      <button
        type="button"
        onClick={() => onShowAll()}
        className="font-medium whitespace-nowrap underline underline-offset-2 hover:text-blue-900"
      >
        Show all {noun}s
      </button>
    </div>
  );
}
